export default __webpack_public_path__ + "static/media/media.823877d3.svg";